import { Component, OnInit } from '@angular/core';
import {MatTabsModule} from '@angular/material/tabs';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import { MeetingComponent } from '../app/meeting/meeting.component';
import { LoginComponent } from '../app/login/login.component';
import { CaroseulComponent } from './caroseul/caroseul.component';
import { SkillComponent } from './skill/skill.component';
import {MissionComponent} from './mission/mission.component';
import { AngularFireModule } from '@angular/fire';
import { LocationComponent } from './location/location.component';
import { FooterComponent } from './footer/footer.component';
import {AngularFireAuth} from '@angular/fire/auth';
import {Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'SullipersonalSite';
  assets: any;

constructor(public afAuth: AngularFireAuth , public router: Router) { }

  ngOnInit(): void {
    this.afAuth.onAuthStateChanged((us) => {
      if (us) {
        this.router.navigate(['meeting']);
      } else {
        this.router.navigate(['']);
      }
    });

  }

}
